import { TaskBusinessHelper } from "../../utils/task-business-helper";
import { BaseParameter } from "../base-parameter";

export interface ITaskParameterModel{
    IsDeleted?: boolean;
    Language?: string;
    Name?: string;
    FromDate?: string;
    ToDate?: string;
    TaskTypeIds?: number[];
    UserIds?: number[];
    Ids?: number[];
	SearchText?: string;
    IsNotDone?: boolean;
    TaskGroupIds?: number[];
    DurationLabelId?: number;
}

export class TaskParameterModel  extends BaseParameter implements ITaskParameterModel{
    IsDeleted: boolean;
    Language: string;
    Name: string;
    FromDate?: string;
    ToDate?: string;
    TaskTypeIds?: number[];
    UserIds?: number[];
    Ids?: number[];
	SearchText?: string;
    IsNotDone?: boolean;
    TaskGroupIds?: number[];
    DurationLabelId?: number;
    /**
     *
     */
    constructor(option: ITaskParameterModel) {
        super();
        this.IsDeleted = option.IsDeleted || false;
        this.Language = option.Language|| null;
        this.Name = option.Name|| null;
        this.FromDate = option.FromDate|| null;
        this.ToDate = option.ToDate|| null;
        this.TaskTypeIds = option.TaskTypeIds|| null;
        this.UserIds = option.UserIds|| [];
        this.Ids = option.Ids || null;
	    this.SearchText = option.SearchText || null;
        this.IsNotDone = option.IsNotDone || true;
        this.TaskGroupIds = option.TaskGroupIds || [];
        this.DurationLabelId = option.DurationLabelId || null;   
        
        if(this.DurationLabelId !== null) {
            let duration = TaskBusinessHelper.getDateDurationFromCombox(this.DurationLabelId);
            if(duration !== null) {
                this.FromDate = duration.FromDate;
                this.ToDate = duration.ToDate;
            }
        }
    }
}